/**
 * lib/haptics.js
 * Wrapper centralizzato per expo-haptics.
 * Su web è un no-op silenzioso — nessun crash, nessun guard necessario.
 */
import { Platform } from 'react-native'

let Haptics = null

if (Platform.OS !== 'web') {
  try {
    Haptics = require('expo-haptics')
  } catch {}
}

// Tap leggero — pill, toggle, selezione
export const hapticLight = () => {
  Haptics?.impactAsync(Haptics.ImpactFeedbackStyle.Light)
}

// Tap medio — bottoni principali, drag pickup
export const hapticMedium = () => {
  Haptics?.impactAsync(Haptics.ImpactFeedbackStyle.Medium)
}

// Successo — pick salvata, flip salvato
export const hapticSuccess = () => {
  Haptics?.notificationAsync(Haptics.NotificationFeedbackType.Success)
}

// Errore — validazione fallita, save fallito
export const hapticError = () => {
  Haptics?.notificationAsync(Haptics.NotificationFeedbackType.Error)
}

// Warning — azione bloccata
export const hapticWarning = () => {
  Haptics?.notificationAsync(Haptics.NotificationFeedbackType.Warning)
}
